var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTechvillage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 41,
    viewBox: "0 0 139 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5201 0H0V19.5201H19.5201V0Z",
    fill: "#2C2C2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5809 5.38867H11.9507L13.6318 8.31512L11.8573 11.2104H10.2695L11.9507 8.31512L10.5809 5.38867Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96102 8.31445H7.56006L5.87891 11.2098L7.65346 14.1362H9.27235L7.59119 11.2098L8.96102 8.31445Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9416 0H21.3281V19.6135H40.9416V0Z",
    fill: "#4CB648"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.135 4.9043L36.5864 14.1207H25.6836L31.135 4.9043ZM27.9316 12.8386H34.3384L31.135 7.42272L27.9316 12.8386Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6135 21.3848H0V40.9982H19.6135V21.3848Z",
    fill: "#4CB648"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.26172 26.6484H14.4106V35.7973H5.26172V26.6484ZM6.44067 27.8274V34.6183H13.2316V27.8274H6.44067Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9416 21.3848H21.3281V40.9982H40.9416V21.3848Z",
    fill: "#4CB648"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.134 27.8798C29.3087 27.8798 27.8212 29.3673 27.8212 31.1925C27.8212 33.0178 29.3087 34.5053 31.134 34.5053C32.9592 34.5053 34.4467 33.0178 34.4467 31.1925C34.4467 29.3673 32.9592 27.8798 31.134 27.8798ZM26.5391 31.1925C26.5391 28.6592 28.6006 26.5977 31.134 26.5977C33.6673 26.5977 35.7288 28.6592 35.7288 31.1925C35.7288 33.7259 33.6673 35.7874 31.134 35.7874C28.6006 35.7874 26.5391 33.7259 26.5391 31.1925Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2071 1.46289V4.38934H57.0354V16.9357H53.9844V4.38934H49.8438V1.46289H61.2071V1.46289Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6565 14.0093H73.1631V16.9357H63.6055V1.46289H73.0697V4.38934H66.6565V7.68938H72.5094V10.5536H66.6565V14.0093V14.0093Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4875 14.9128C75.962 13.3562 75.2148 11.4571 75.2148 9.1844C75.2148 6.91173 75.962 4.98152 77.4875 3.45603C79.013 1.89941 80.9432 1.12109 83.247 1.12109C86.0489 1.12109 88.5707 2.52206 89.9094 4.76359L87.2942 6.28908C86.5159 4.88812 85.0527 4.07868 83.2782 4.07868C81.7838 4.07868 80.5696 4.54567 79.6357 5.47964C78.7328 6.44475 78.2658 7.65891 78.2658 9.15327C78.2658 10.6476 78.7328 11.8618 79.6357 12.7958C80.5696 13.7609 81.7838 14.1967 83.2782 14.1967C85.0527 14.1967 86.5782 13.3562 87.2942 12.0175L89.9094 13.5429C88.5707 15.7845 86.0801 17.1854 83.247 17.1854C80.9432 17.2477 79.013 16.4694 77.4875 14.9128Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M101.307 1.46289H104.326V16.9357H101.307V10.5224H95.5471V16.9357H92.4961V1.46289H95.5471V7.59599H101.307V1.46289Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0116 39.5705L49.8125 24.0977H53.1125L56.8796 35.9903L60.6466 24.0977H64.0089L58.7787 39.5705H55.0116Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2148 24.0977H69.2658V39.5705H66.2148V24.0977Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8674 36.644H81.7826V39.5705H72.8164V24.0977H75.8674V36.644Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2658 36.644H93.181V39.5705H84.2148V24.0977H87.2658V36.644Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M105.977 39.5705L105.043 36.7997H98.8785L97.9446 39.5705H94.6445L100.062 24.0977H103.86L109.308 39.5705H105.977ZM99.8748 33.9355H104.109L101.992 27.6156L99.8748 33.9355Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M126.147 31.2589V32.4419C126.147 34.6523 125.431 36.4269 124.03 37.8279C122.629 39.1977 120.792 39.8826 118.551 39.8826C116.154 39.8826 114.161 39.1043 112.604 37.5477C111.048 35.991 110.27 34.092 110.27 31.8504C110.27 29.6089 111.048 27.7098 112.604 26.122C114.161 24.5654 116.091 23.7871 118.395 23.7871C121.29 23.7871 123.812 25.1881 125.151 27.3985L122.536 28.8928C121.82 27.6475 120.201 26.7447 118.395 26.7447C116.901 26.7447 115.687 27.2428 114.753 28.2079C113.787 29.173 113.352 30.3872 113.352 31.8504C113.352 33.3136 113.85 34.5278 114.784 35.4618C115.749 36.4269 117.025 36.8627 118.644 36.8627C121.01 36.8627 122.598 35.7731 123.158 33.9363H118.457V31.2278H126.147V31.2589Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M132.063 36.644H138.569V39.5705H129.012V24.0977H138.476V27.0241H132.063V30.3241H137.916V33.1883H132.063V36.644V36.644Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechvillage);
export default __webpack_public_path__ + "static/media/techvillage.0dc2c2568f4a142b67e938a242f1f3c1.svg";
export { ForwardRef as ReactComponent };